/*
 * Copyright (c) 2026 Paxia AI Pty Ltd. All rights reserved.
 * This software is proprietary and confidential.
 * No part of this codebase may be copied, modified, published, distributed, sublicensed, or used without prior written permission from Paxia AI Pty Ltd.
 */

import React from 'react';

export const Segmented = ({ value, onChange, options, tiny = false }) => (
  <div className={`inline-flex items-center ${tiny ? 'p-0.5 rounded-md' : 'p-1 rounded-md'} bg-muted`}>
    {options.map((o) => (
      <button
        key={o.value}
        type="button"
        onClick={() => onChange(o.value)}
        className={`px-2 ${tiny ? 'py-0.5 text-xs' : 'py-1 text-sm'} rounded-md transition ${
          value === o.value ? 'bg-background text-textPrimary shadow-sm' : 'text-textSecondary hover:text-textPrimary'
        }`}
      >
        {o.label}
      </button>
    ))}
  </div>
);
